import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

@Injectable({
    providedIn: "root",
})
export class NotificationsService {
    constructor(
        private toastr: ToastrService,
        private translate: TranslateService,
    ) {}

    showSuccess(title: string, message: string, messageParams?: Record<string, unknown>): void {
        this.toastr.success(this.translate.instant(message, messageParams), this.translate.instant(title));
    }

    showError(title: string, message: string, messageParams?: Record<string, unknown>): void {
        this.toastr.error(this.translate.instant(message, messageParams), this.translate.instant(title));
    }
}
